export default "__VITE_ASSET__64dbe23a__"